import { formatNumber, ymEvent } from "helpers/system";
import React from "react";

export default function ExternalBidInfo(props) {
    const openExternalDistributionBid = (e) => {
        e.stopPropagation();
        const { carId, modal } = props;
        ymEvent("ExternalDisBids");
        return modal({
            name: "externalDistributionBid",
            title: "Информация по внешнему заказу",
            windowMod: "wide",
            carId,
            organization: props.organization,
        });
    };
    return (
        <div className="map__external-bid" onClick={openExternalDistributionBid}>
            <i className="icon-uEA86-exclamation-circle pr-1 map__external-bid--icon" />
            Следующая заявка со ставкой от {formatNumber(props.externalBidOutput)}{" "}
            {props.organization?.currencyData?.name}/км
        </div>
    );
}
